// Hook per rilevare se l'utente è su mobile (sia per UA che per viewport)
import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768;

function detectMobile() {
  if (typeof window === "undefined") return false;
  // Viewport-based (priority): pratico per testing e su tablet ruotato
  if (window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches) return true;
  // UA fallback (per garantire mobile-mode su touch device anche con viewport ampio)
  const ua = navigator.userAgent || "";
  return /Android|iPhone|iPad|iPod|IEMobile|Opera Mini|Mobile/i.test(ua) && window.innerWidth <= 1024;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(detectMobile);
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => setIsMobile(detectMobile());
    mq.addEventListener?.("change", onChange);
    window.addEventListener("resize", onChange);
    return () => {
      mq.removeEventListener?.("change", onChange);
      window.removeEventListener("resize", onChange);
    };
  }, []);
  return isMobile;
}

// Helper standalone (non hook) per uso fuori da React
export function isMobileDevice() {
  return detectMobile();
}
